import gql from 'graphql-tag'
export const GET_COURSES = gql`
  query {
    cursos {
      _id
      titulo
      descricao
      capa
      progresso
      ultimo_conteudo
      apresentacao
      primeiro_conteudo
      emiteCertificado
      corpoCertificado
      imgCertificado
      imgVersoCertificado
      requisitoCertificado     
    }
  }
`

export const GET_COURSES_ALL = gql`
  query {
    cursos_all {
      _id
      titulo
      descricao
      capa
      progresso
      ultimo_conteudo
      apresentacao
      primeiro_conteudo
      emiteCertificado
      corpoCertificado
      imgCertificado
      imgVersoCertificado
      requisitoCertificado     
    }
  }
`

export const GET_COURSE = gql`
  query curso($id: String!) {
    curso(_id: $id) {
      forum
      cronograma
      apresentacao
      titulo
      progresso
      trilhas {
        titulo
        items {
          _id
          titulo
          conteudos {
            _id
            tipo
            subtipo
            titulo
            professor
            tempo
          }
        }
      }
    }
  }
`
export const GET_COURSE_DEMAND_LOAD = gql`
  query curso($id: String!) {
    curso(_id: $id) {
      forum
      cronograma
      apresentacao
      titulo
      progresso
      trilhas {
        titulo
        items {
          _id
          titulo
        }
      }
    }
  }
`

export const GET_TRAIL_CONTENT = gql`
  query conteudosTrilha($trilha_id: String!) {
    conteudosTrilha(trilha_id: $trilha_id) {
      _id
      titulo
      tipo
      descricao
      professor
      tempo
      subtipo
    }
  }
`

// export const GET_COURSE = gql`
//   query curso($id: String!) {
//     curso(_id: $id) {
//       progresso
//     }
//   }
// `

export const GET_LAST_VISITED_CONTENT = gql`
  query ultimoConteudoAcessado($curso_id: String!) {
    ultimoConteudoAcessado(curso_id: $curso_id) {
      _id
    }
  }
`

export const GET_COURSE_PROGRESS = gql`
  query progressoCurso($curso_id: String!) {
    progressoCurso(curso_id: $curso_id) {
      _id
      conteudos_concluidos
    }
  }
`

export const GET_ALL_ANSWERS = gql`
  query todasRespostasPergunta($pergunta_id: String!) {
    todasRespostasPergunta(pergunta_id: $pergunta_id) {
      _id
      comentario
      certa
    }
  }
`
export const GET_ALL_QUIZ_ANSWERS = gql`
  query todasRespostasQuiz($conteudo_id: String!) {
    todasRespostasQuiz(conteudo_id: $conteudo_id) {
      _id
      pergunta_id
      numero
      resposta
      comentario
      certa
    }
  }
`